(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projects-slider-wide"] && !Shopify.designMode) return;
  try {
    
  (function () {
  class ProjectsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.active = 0;
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.scrollToIndex(i));
      });
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scrollToIndex(this.active - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scrollToIndex(this.active + 1));
      this.track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => this.syncActive());
      }, { passive: true });
      window.addEventListener('resize', () => this.syncActive());

      // Lightbox-ul e component separat. Sincronizarea se face la INCHIDERE:
      // cat timp <dialog> e modal, browserul ignora scroll-ul programatic al
      // paginii din spate, deci scrollToIndex chemat mai devreme n-ar avea efect.
      this.addEventListener('projects-lightbox:close', (e) => {
        if (e.detail && typeof e.detail.index === 'number') this.scrollToIndex(e.detail.index);
      });

      this.setupDrag();
      this.syncActive();
    }

    setupDrag() {
      const track = this.track;
      const DRAG_THRESHOLD = 4;
      let isDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;

        // Capture-ul se ia ABIA cand incepe tragerea. Luat pe pointerdown,
        // browserul retargeteaza pointerup si click catre track, deci un click
        // simplu nu mai ajunge niciodata la cardul de dedesubt.
        if (!moved) {
          if (Math.abs(dx) <= DRAG_THRESHOLD) return;
          moved = true;
          track.classList.add('is-dragging');
          try {
            track.setPointerCapture(e.pointerId);
          } catch (err) {
            /* pointer deja eliberat; tragerea merge si fara capture */
          }
        }

        track.scrollLeft = startScroll - dx;
      });

      const end = () => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
      };
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('pointerleave', end);

      track.addEventListener('click', (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
    }

    indexForScroll(scrollLeft) {
      const base = scrollLeft + this.track.offsetLeft;
      let index = 0;
      let min = Infinity;
      this.slides.forEach((slide, i) => {
        const dist = Math.abs(slide.offsetLeft - base);
        if (dist < min) {
          min = dist;
          index = i;
        }
      });
      return index;
    }

    // Cand mai multe carduri incap pe ecran, ultimele nu mai pot fi aduse la marginea
    // stanga: scrollul se opreste inainte. Peste acest index nu exista pozitie atinsa.
    lastIndex() {
      return this.indexForScroll(this.track.scrollWidth - this.track.clientWidth);
    }

    scrollToIndex(i) {
      const last = this.lastIndex();
      const idx = Math.max(0, Math.min(i, last));
      const slide = this.slides[idx];
      if (!slide) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = idx === last ? max : slide.offsetLeft - this.track.offsetLeft;
      this.track.scrollTo({ left, behavior: 'smooth' });
    }

    syncActive() {
      const last = this.lastIndex();
      const active = Math.min(this.indexForScroll(this.track.scrollLeft), last);
      this.active = active;
      this.dots.forEach((dot, i) => {
        dot.hidden = i > last;
        dot.classList.toggle('is-active', i === active);
      });
      this.updateNav();
    }

    updateNav() {
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 1;
      if (this.nextBtn) {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 1;
      }
    }
  }

  if (!customElements.get('projects-slider')) {
    customElements.define('projects-slider', ProjectsSlider);
  }
  })();

  } catch(e) { console.error(e); }
})();
})();
